import React from 'react'

import { get, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { UrlQueryParamTypes, addUrlProps } from 'react-url-query'
import { reduxRequiredActions, routeRequiredActions } from 'required-actions'

import { selectProspectByScid } from 'store/prospects'

const sources = ['CM', 'CoalitionMember']

export const Home = ({ prospectId, verifyInterrupt, referralSource, requiredActions }) => {
  const requiredActionsList = verifyInterrupt ? requiredActions : []
  const isCoalition = sources.includes(referralSource)

  if (!isEmpty(requiredActionsList)) {
    return <Redirect to={routeRequiredActions(requiredActionsList)} />
  }
  if (verifyInterrupt && isCoalition) {
    return <Redirect to={`${import.meta.env.BASE_URL}/app-profile${prospectId ? `?prospectId=${prospectId}` : ''}`} />
  }
  return <Redirect to={`${import.meta.env.BASE_URL}/dashboard`} />
}

Home.propTypes = {
  referralScid: PropTypes.number,
  prospectId: PropTypes.string,
  verifyInterrupt: PropTypes.bool,
  requiredActions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}

export const ConnectedHome = connect((store, props) => ({
  requiredActions: reduxRequiredActions(store),
  prospectId: props.referralScid ? get(selectProspectByScid(store, props.referralScid), 'Id') : undefined,
}))(Home)

const urlPropsQueryConfig = {
  verifyInterrupt: {
    type: UrlQueryParamTypes.boolean,
    queryParam: 'interrupt',
  },
  referralScid: {
    type: UrlQueryParamTypes.number,
    queryParam: 'referralScid',
  },
  referralSource: {
    type: UrlQueryParamTypes.string,
    queryParam: 'referralSource',
  },
}

const EnhancedConnectedHome = addUrlProps({ urlPropsQueryConfig })(ConnectedHome)
export default EnhancedConnectedHome
